import React from 'react';

import { PlusOutlined } from '@ant-design/icons';
import { Button as AntdButton } from 'antd';

import { useModal } from 'hooks/modal/useModal';

import ModalCreate from '../Modals/ModalCreate';

import './DashboardHeader.less';

interface DashboardHeaderProps {
  totalCount: number;
  refreshDashboard: () => void;
}

export function DashboardHeader({
  totalCount,
  refreshDashboard,
}: DashboardHeaderProps): React.ReactElement {
  const modalCreation = useModal();
  const countString = `${totalCount} branche${
    totalCount > 1 ? 's' : ''
  } trouvée${totalCount > 1 ? 's' : ''}`;

  return (
    <div>
      <div className="dashboard-header-fields header-referentiels">
        <div>
          {/* placeholder de Filter pour conserver le CSS des autres pages*/}
        </div>
        <AntdButton
          icon={<PlusOutlined />}
          type={'primary'}
          shape={'round'}
          onClick={modalCreation.open}
        >
          Créer une branche
        </AntdButton>
        <ModalCreate
          visible={modalCreation.visible}
          close={modalCreation.close}
          refreshDashboard={refreshDashboard}
        />
      </div>
      <p>{countString}</p>
    </div>
  );
}

export default DashboardHeader;
